import React, { useCallback, useEffect, useState, useRef } from "react";

const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

const MultiRangeSlider = ({ min=0, max=100,initVal, onChange, label = "Ages", limit = 0, labelAlign="start", minLimit=0, closeButton=false, disableRange=false  }) => {
  
   // Sanitize the incoming value so it always fits the slider's scale and limit
  const safeMin = clamp(initVal?.min ?? min, minLimit, max - 1);
  let safeMax = clamp(initVal?.max ?? max, safeMin + 1, max);
  if (limit > 0 && safeMax - safeMin > limit) safeMax = safeMin + limit;
  
  const [minVal, setMinVal] = useState(initVal?.min || min);
  const [maxVal, setMaxVal] = useState(initVal?.max || max);
  const [touched, setTouched] = useState(false);
  // const minValRef = useRef(min);
  // const maxValRef = useRef(max);
  const range = useRef(null);

  const resetToInitial = useCallback(() => {
    const resetMin = min;
    const resetMax = max;
    setMinVal(resetMin);
    setMaxVal(resetMax);
    setTouched(false);
    // Notify parent of reset
    if (typeof onChange === "function") onChange({ min: min, max: max });
  }, [min, max, onChange]);

  // Convert to percentage
  const getPercent = useCallback(
    // (value) => ((value - min) / (max - min)) * 100,
    (value) => clamp(((value - minLimit) / (max - minLimit)) * 100, 0, 100),
    [minLimit, max]
  ); 
  // Update the slider range styling
  useEffect(() => {
    // const minPercent = getPercent(initVal?.min);
    // const maxPercent = getPercent(initVal?.max);
    // setMinVal(initVal?.min);
    // setMaxVal(initVal?.max);
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${Math.max(0, maxPercent - minPercent)}%`;
    }
  }, [minVal, maxVal, getPercent,initVal]);

  useEffect(() => {
  if (safeMin !== initVal?.min || safeMax !== initVal?.max) {
    onChange?.({ min: safeMin, max: safeMax });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return (
  <div className={`container-range ${closeButton && !touched ? "slider--gray" : ""}`}>
      <input
        // disabled={disableRange}
        type="range"
        min={minLimit}
        max={max}
        value={minVal}
        onChange={(event) => {
          if (!touched) setTouched(true);
          let value = Math.min(Number(event.target.value), maxVal - 1);
          let updatedMax = maxVal;
          
          if (limit > 0) {
            const checkLimit = Math.abs(value - maxVal);
            if (checkLimit > limit) {
              updatedMax = value + limit;
            }
          }
          
          setMinVal(value);
          setMaxVal(updatedMax);
          // minValRef.current = value;
          onChange({ min: value, max: updatedMax });
        }}
        className="thumb thumb--left"
      />
      
      <input
        // disabled={disableRange}
        type="range"
        min={minLimit}
        max={max}
        value={maxVal}
        onChange={(event) => {
          if (!touched) setTouched(true);
          let value = Math.max(Number(event.target.value), minVal + 1);
          let updatedMin = minVal;
          
          if (limit > 0) {
            const checkLimit = Math.abs(value - minVal);
            if (checkLimit > limit) {
              updatedMin = value - limit;
            }
          }
          
          setMaxVal(value);
          setMinVal(updatedMin);
          // maxValRef.current = value;
          onChange({ min: updatedMin, max: value });
        }}
        className="thumb thumb--right"
      />

  <div className="slider">
    <div className="slider__track" />
    <div ref={range} className="slider__range" />
        {
            labelAlign === "start" ?
            <div className="slider__left-value w-full text-center font-bold">{label} {minVal} - {maxVal}</div>
            :
            <div className="slider__left-value w-full text-center font-bold">{minVal} - {maxVal} {label}</div>

        }
        {/* Close/reset button: visible when closeButton is true and user has interacted (touched) */}
        {closeButton && touched && (
          <button
            type="button"
            className="multi-range-close"
            onClick={resetToInitial}
            aria-label="Reset range"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default MultiRangeSlider;
